import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../axiosSetup";
import "./LoginPage.css";

const SendResetLinkPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email; // email from LoginPage

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleGenerateLink = async () => {
    setLoading(true);
    setMessage("");

    try {
      await axios.post("/auth/generate-reset-link", { email });

      setMessage(
        "A password reset link has been sent to your email. Please check your inbox."
      );
    } catch (err) {
      setMessage(
        err.response?.data?.message || "Failed to send reset link. Try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="lp-page">
      <div className="lp-card">
        <h2 className="lp-title">Reset Password</h2>

        <p style={{ marginBottom: 15 }}>
          We found your account: <strong>{email}</strong>
        </p>

        <p style={{ marginBottom: 20 }}>
          Click below and we will send a password reset link to your email.
        </p>

        {message && <div className="lp-success">{message}</div>}

        <button
          className="lp-primary-btn"
          onClick={handleGenerateLink}
          disabled={loading}
        >
          {loading ? "Sending..." : "Generate Reset Link"}
        </button>

        <div style={{ marginTop: 20, textAlign: "center" }}>
          <button
            className="lp-link-btn"
            onClick={() => navigate("/login")}
          >
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default SendResetLinkPage;
